import { ReduxRoot } from 'types/ReduxStore'

const createNotificationSelector = (state: ReduxRoot) => state.notificationStore

export default createNotificationSelector
